const allowedKeys = ['w', 'h', 'r'];

module.exports = {
    getSrc: (imageUrl, queryParams = {}) => {
        if (!imageUrl) throw new Error('Requires image URL');
        if (Object.keys(queryParams).length === 0) {
            return `https:${imageUrl}`
        }

        const filteredQueryParams = Object.keys(queryParams)
            .filter(key => allowedKeys.includes(key))
            .reduce((obj, key) => {
                obj[key] = queryParams[key];
                return obj;
            }, {});

        const queryString = Object.keys(filteredQueryParams).map(key => key + '=' + filteredQueryParams[key]).join('&');
        return `https:${imageUrl}?${queryString}`;
    },
};
